<template>
    <div>
        <b-modal
            size="md"
            v-model="modalShow"
            :title="title"
            ok-title="登録"
            ok-variant="yokumiru-orange"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="close"
            @hidden="close">
            <div v-show="beforeReservation" class="vc-box mb-3 small font-weight-bold">
                予約にはクレジットカードの登録が必要です。
            </div>

            <form @submit.stop.prevent="store">
                <div class="form-group">
                    <label>カード番号</label>
                    <div id="el-card-number"></div>
                </div>

                <div class="form-group">
                    <label>有効期限</label>
                    <div id="el-card-expiry"></div>
                </div>

                <div class="form-group">
                    <label>カード名義</label>
                    <input
                        v-model="name"
                        id="name"
                        class="form-control m-input"
                        :class="{ 'is-invalid' : errors.name }"
                        type="text"
                        :placeholder="`${$locale.appName} TARO`">
                    <div v-if="errors.name" class="invalid-feedback d-block mt-1">
                        {{ errors.name[0] }}
                    </div>
                </div>

                <div class="form-group">
                    <label>セキュリティコード</label>
                    <div id="el-card-cvc"></div>
                </div>

                <div v-if="errors.message"
                     class="invalid-feedback d-block">
                    {{ errors.message[0] }}
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'
    import {loadStripe} from '@stripe/stripe-js'

    export default {
        name: "StoreCreditCardModal",

        props: {
            dataPubkey: {
                type: String,
                default: null,
            },
            title: {
                type: String,
                default: 'クレジットカードを登録',
            },
            beforeReservation: {
                type: Boolean,
                default: false,
            },
        },

        data: function () {
            return {
                modalShow: false,
                pubkey: null,
                stripe: null,
                elements: null,
                name: null,
                cardNumber: null,
                cardExpiry: null,
                cardCvc: null,
                intent: null,
                inProgress :false,
                errors: {},
            }
        },

        created: function () {
            if (this.dataPubkey) {
                this.pubkey = this.dataPubkey
            }

            bus.$on('open-modal-store-credit-card', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-store-credit-card')
        },

        methods: {
            /**
             * モーダル表示
             *
             * @param {string|null} pubkey
             */
            open: async function (pubkey = null) {
                if (pubkey) {
                    this.pubkey = pubkey
                }

                this.stripe = await loadStripe(this.pubkey, {locale: "ja"})
                this.elements = this.stripe.elements({locale: "ja"})

                this.cardNumber = this.elements.create('cardNumber', {
                    classes: {base: 'StripeElement form-control form-control--stripe'},
                    showIcon: true,
                })
                this.cardExpiry = this.elements.create('cardExpiry', {
                    classes: {base: 'StripeElement form-control form-control--stripe'},
                })
                this.cardCvc = this.elements.create('cardCvc', {
                    classes: {base: 'StripeElement form-control form-control--stripe'},
                })

                this.modalShow = true

                let timer = null
                timer = setInterval(() => {
                    const isMounted = !!document.getElementById('el-card-number')
                        && !!document.getElementById('el-card-expiry')
                        && !!document.getElementById('el-card-cvc')

                    if (isMounted) {
                        clearInterval(timer)
                        this.cardNumber.mount('#el-card-number')
                        this.cardExpiry.mount('#el-card-expiry')
                        this.cardCvc.mount('#el-card-cvc')
                    }
                }, 100)
            },

            handleOk(e) {
                e.preventDefault()
                this.store()
            },

            store: async function () {
                if (this.inProgress) return
                this.inProgress = true

                if (!this.intent) {
                    await axios.get(constants.user.credit_cards.endpoint.setup_intent)
                        .then(({data}) => {
                            this.intent = data.data
                        })
                }

                this.stripe
                    .confirmCardSetup(this.intent.client_secret, {
                        payment_method: {
                            card: this.elements.getElement('cardNumber'),
                            billing_details: {
                                name: this.name,
                            },
                        },
                    })
                    .then(result => {
                        if (result.setupIntent && result.setupIntent.status === "succeeded") {
                            this.clearSetupCardState()
                            bus.$emit('credit-card-stored', result.setupIntent.payment_method)
                            bus.$emit('alert-success', 'カードを登録しました。')
                            this.close()
                            this.inProgress = false
                        }
                        else {
                            this.errors.message = [result.error.message]
                            this.inProgress = false
                        }
                    })
            },

            /**
             * カード情報入力状態の初期化
             */
            clearSetupCardState: function () {
                this.intent = null
                this.cardNumber.clear()
                this.cardExpiry.clear()
                this.cardCvc.clear()
                this.name = null
            },

            close: function () {
                this.initialize()
                this.modalShow = false
            },

            initialize: function() {
                this.errors = {}
            },
        },
    }
</script>

<style scoped lang="scss">
.vc-box {
    padding: 12px 15px;
    background: #ebebeb;
}
</style>

<style lang="scss">
.form-control {
    &.form-control--stripe {
        padding-top: 0.6rem !important;
    }
}
</style>
